import emailjs from "@emailjs/browser";
import { EMAILJS_CONFIG } from "@/config/emailjs.config";

// EmailJS Configuration
const SERVICE_ID = EMAILJS_CONFIG.SERVICE_ID;
const TEMPLATE_ID = EMAILJS_CONFIG.TEMPLATE_ID;
const PUBLIC_KEY = EMAILJS_CONFIG.PUBLIC_KEY;
const ADMIN_EMAIL = EMAILJS_CONFIG.ADMIN_EMAIL;

// Initialize EmailJS
if (PUBLIC_KEY) {
  emailjs.init(PUBLIC_KEY);
  console.log("✅ EmailJS initialized successfully");
} else {
  console.warn("⚠️  EmailJS Public Key not configured. Email notifications will be disabled.");
}

/**
 * Format email body from form data
 * @param {string} type - Form type (contact, quote, custom, newsletter)
 * @param {object} data - Form data
 * @returns {string} Formatted email body
 */
const formatEmailBody = (type, data) => {
  const timestamp = new Date().toLocaleString("en-IN", { timeZone: "Asia/Kolkata" });
  
  let body = `━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\n`;
  body += `ElitzPacks - New ${type.toUpperCase()} Submission\n`;
  body += `━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\n\n`;
  body += `📅 Submitted: ${timestamp}\n`;
  body += `📧 From: ${data.email || "N/A"}\n`;
  body += `👤 Name: ${data.name || "N/A"}\n\n`;

  if (type === "contact") {
    body += `━━━ CONTACT DETAILS ━━━\n`;
    body += `📞 Phone: ${data.phone || "N/A"}\n`;
    body += `📌 Subject: ${data.subject || "N/A"}\n`;
    body += `💬 Message:\n${data.message || "N/A"}\n`;
  } 
  else if (type === "quote") {
    body += `━━━ QUOTE REQUEST ━━━\n`;
    body += `🏢 Company: ${data.company || "N/A"}\n`;
    body += `📍 City: ${data.city || "N/A"}\n`;
    body += `📦 Product: ${data.product || "N/A"}\n`;
    body += `📊 Quantity: ${data.quantity || "N/A"}\n`;
    body += `💬 Message:\n${data.message || "N/A"}\n`;
    if (data.artwork_name) body += `📄 Artwork: ${data.artwork_name}\n`;
  } 
  else if (type === "custom") {
    body += `━━━ CUSTOM PACKAGING ━━━\n`;
    body += `🏢 Company: ${data.company || "N/A"}\n`;
    body += `📍 City: ${data.city || "N/A"}\n`;
    body += `📏 Material: ${data.material || "N/A"}\n`;
    body += `📐 Dimensions: ${data.dimensions || "N/A"}\n`;
    body += `🖨️  Printing: ${data.printing || "N/A"}\n`;
    body += `✨ Finish: ${data.finish || "N/A"}\n`;
    body += `📊 Quantity: ${data.quantity || "N/A"}\n`;
    body += `💬 Message:\n${data.message || "N/A"}\n`;
    if (data.artwork_name) body += `📄 Artwork: ${data.artwork_name}\n`;
  } 
  else if (type === "newsletter") {
    body += `━━━ NEWSLETTER SUBSCRIPTION ━━━\n`;
    body += `Email added to mailing list.\n`;
  }

  body += `\n━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\n`;
  return body;
};

/**
 * Send email via EmailJS with formatted body
 * @param {string} type - Form type (contact, quote, custom, newsletter)
 * @param {object} data - Form data
 * @returns {Promise}
 */
export const sendEmail = async (type, data) => {
  // If EmailJS not configured, skip
  if (!PUBLIC_KEY) {
    console.log("📧 EmailJS disabled. Form data will be saved to database only.");
    return { status: "skipped", message: "EmailJS not configured" };
  }

  try {
    // Format the email body on frontend
    const emailBody = formatEmailBody(type, data);

    // Send simple email with just 3 variables
    const emailParams = {
      to_email: ADMIN_EMAIL,
      from_email: data.email || "noreply@elitzpacks.com",
      email_body: emailBody,
    };

    const response = await emailjs.send(SERVICE_ID, TEMPLATE_ID, emailParams);
    console.log("✅ Email sent successfully:", response.status);
    return response;
  } catch (error) {
    console.error("❌ EmailJS Error:", error);
    // Don't throw - let form still submit even if email fails
    return { status: "error", message: error.message };
  }
};

export default emailjs;
